module.exports = __webpack_public_path__ + "static/media/05_avatar_animal.f445895d.png";